export default class AppMenu {
    constructor($el) {
        this.$el = $el;
        this.$hamburgerOpen = this.$el.querySelector('[data-hamburger-open]');
        this.$hamburgerClose = this.$el.querySelector('[data-hamburger-close]');
        this.$menu = this.$el.querySelector('[data-menu]')

        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);

        this.$hamburgerOpen.addEventListener('click', this.openMenu);
        this.$hamburgerClose.addEventListener('click', this.closeMenu);

    }

    openMenu(e) {
        e.preventDefault();
        this.$menu.classList.add('app__menu--open');
    }

    closeMenu(e) {
        e.preventDefault();
        this.$menu.classList.remove('app__menu--open');
    }
}